<template>
  <div>
    <div class="banner">
      <h4>Adicionar Grupo Sanguíneo</h4>
    </div>

    <v-form @submit.prevent="create" ref="form">
      <v-row dense v-if="!resource.id">
        <v-col class="d-flex" cols="12" sm="6">
          <v-autocomplete :rules="formRules" :items="patients" color="#256936" class="rounded-lg"
            v-model="bloodGroupForm.donor_id" item-value="id" item-text="name" dense outlined
            label="Paciente/Potencial Doador" @change="changeCPF()">
            <template v-slot:label>
              Potencial Doador <span style="color: red">*</span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field color="#256936" :rules="formRules" class="rounded-lg" label="CPF" disabled outlined
            v-model="cpf" maxlength="14" v-mask="'###.###.###-##'" dense>
            <template v-slot:label>
              CPF <span style="color: red">*</span>
            </template>
          </v-text-field>
        </v-col>
      </v-row>

      <v-row dense v-else>
        <v-col cols="12">
          <v-card class="pa-4 prontuario-card" elevation="1">

            <div class="prontuario-header mb-3">
              <v-icon class="mr-2" color="#41916b">mdi-file-document</v-icon>
              <span>Dados do Paciente</span>
            </div>

            <v-divider class="mb-3"></v-divider>

            <v-list dense class="prontuario-list">
              <v-list-item v-for="(item, i) in patientDescription" :key="i" class="prontuario-item">
                <v-row no-gutters align="center">

                  <v-col cols="1" class="d-flex justify-center">
                    <v-icon size="18" color="#41916b">
                      {{ item.icon }}
                    </v-icon>
                  </v-col>

                  <v-col cols="4" class="prontuario-label">
                    {{ item.label }}
                  </v-col>

                  <v-col cols="7" class="prontuario-value">
                    {{ item.text }}
                  </v-col>

                </v-row>
              </v-list-item>
            </v-list>

          </v-card>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row dense class="mt-4">
        <v-col class="d-flex" cols="12" sm="12">
          <v-text-field color="#256936" class="rounded-lg" outlined v-model="bloodGroupForm.report_number" dense>
            <template v-slot:label>
              Nº do Laudo/AAAA
            </template>
          </v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field color="#086318" class="rounded-lg" :rules="formRules" :max="maxDate"
            @input="onlyDateInput('sample_date', $event)" type="date" outlined v-model="bloodGroupForm.sample_date"
            dense>
            <template v-slot:label>
              Data da Coleta de Amostra
              <span style="color: red">*</span>
            </template>
          </v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field color="#256936" class="rounded-lg" type="datetime-local"
            @input="onDateTimeInput('release_date', $event)" :max="maxDateTime" outlined
            v-model="bloodGroupForm.release_date" dense>
            <template v-slot:label>
              Data e Horário da Liberação
            </template>
          </v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-autocomplete :rules="formRules" :items="exames_types" color="#256936" class="rounded-lg"
            v-model="bloodGroupForm.type_report_id" item-value="value" item-text="description" dense outlined>
            <template v-slot:label>
              Tipo de Exame <span style="color: red">*</span>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-autocomplete :rules="formRules" :items="blood_factors" color="#256936" class="rounded-lg"
            v-model="bloodGroupForm.blood_factor_id" item-value="id" item-text="description" dense outlined>
            <template v-slot:label>
              Fator Sanguíneo <span style="color: red">*</span>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row dense class="mt-4">
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field color="#256936" class="rounded-lg" :rules="formRules" v-model="bloodGroupForm.responsible_name"
            outlined dense>
            <template v-slot:label>
              Nome do Responsável <span style="color: red">*</span>
            </template>
          </v-text-field>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field color="#256936" class="rounded-lg" :rules="formRules" v-model="bloodGroupForm.advice" outlined
            dense>
            <template v-slot:label>
              Conselho <span style="color: red">*</span>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col class="d-flex justify-center" cols="12" sm="12">
          <v-btn small class="rounded-lg" color="#41916b" type="submit" :loading="loading">
            <span class="spanColor">{{$t('buttons.save')}}</span>
          </v-btn>
          <v-btn small class="rounded-lg ml-1" @click="closeDialog();">
            <span>{{$t('buttons.cancel')}}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import { getFactors, getPatientsNotBloodGroups } from "@/service/SerologyService";
import currentUser from "@/utils/currentUser";
import axios from "@/axios";
export default {
  data() {
    return {
      items: [],
      formRules: [
        v => !!v || 'Campo Obrigatorio',
      ],
      bloodGroupForm: {},
      exames_types: [
        { value: "1", description: "Córnea" },
        { value: "2", description: "Esclera" },
        { value: "3", description: "Múltiplos Orgãos" },
      ],
      blood_factors: [],
      patients: [],
      loading: false,
      cpf: '',
    }
  },

  computed: {
    ...mapGetters({
      patientData: 'getBloodGroupsPatientData'
    }),

    patientDescription() {
      return [
        { icon: 'mdi-account', label: 'Nome', text: this.resource.name },
        { icon: 'mdi-account', label: 'Tipo de Paciente', text: this.resource.kind_of_donor.name },
        { icon: 'mdi-card-account-details', label: 'CPF', text: this.resource.cpf },
        { icon: 'mdi-hospital', label: 'Hospital', text: this.resource.unities.hospital },
      ]
    },
    currentUser() {
      return currentUser.getUserData();
    },
  },

  created() {
    this.getSelectsItems()
  },

  props: {
    resource: {
      type: Object,
    }
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),
    async getSelectsItems() {
      this.blood_factors = await getFactors();
      this.patients = await getPatientsNotBloodGroups();
    },

    changeCPF() {
      if (this.bloodGroupForm.donor_id == null) return;

      this.cpf = this.patients.find((x) => x.id == this.bloodGroupForm.donor_id);
      this.cpf = this.cpf.cpf
    },

    maxDateTime() {
      const now = new Date();
      return now.toISOString().slice(0, 16);
    },

    maxDate() {
      const now = new Date();
      return now.toISOString().slice(0, 10);
    },

    formatDateTimeToBackend(value) {
      if (!value) return null;
      return value.replace("T", " ").slice(0, 16);
    },
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true
        let donor_id = this.bloodGroupForm.donor_id
          ? this.bloodGroupForm.donor_id
          : this.resource.id;

        let data = {
          user_id: this.currentUser.id,
          donor_id: donor_id,
          type_report_id: this.bloodGroupForm.type_report_id,
          report_number: this.bloodGroupForm.report_number,
          sample_date: this.bloodGroupForm.sample_date,
          release_date: this.formatDateTimeToBackend(
            this.bloodGroupForm.release_date,
          ),
          responsible_name: this.bloodGroupForm.responsible_name,
          advice: this.bloodGroupForm.advice,
          blood_factor_id: this.bloodGroupForm.blood_factor_id,
        };

        axios({
          method: this.bloodGroupForm.id ? "PUT" : "POST",
          url: this.bloodGroupForm.id
            ? `/blood_groups/${this.bloodGroupForm.id}`
            : `blood_groups/create`,
          data: data,
        })
          .then((response) => {
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

            setTimeout(() => {
              this.loading = false;
              this.closeDialog();
              this.closeSnackBar()
              this.$emit('reloadGrid', true)
            }, 3000);
          })
          .catch((err) => {
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: err.error,
              bodyMessage: err.details,
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => this.closeSnackBar(), 5000);
          });
      }
    },

    closeDialog() {
      this.$emit("closeDialog", false);
      this.bloodGroupForm = {};
      this.cpf = '';
      this.$refs.form.resetValidation();
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  }

}
</script>
<style scoped>
.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 20px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}

.spanColor {
  color: #ffffff;
}

.prontuario-card {
  background: #f7faf9;
  border-radius: 12px;
  border: 1px solid #e1e3e2;
}

.prontuario-header {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #2e2e2e;
}

.prontuario-list {
  padding: 0;
}

.prontuario-item {
  padding: 6px 0;
  border-bottom: 1px dashed #dcdcdc;
}

.prontuario-item:last-child {
  border-bottom: none;
}

.prontuario-label {
  font-size: 13px;
  color: #6b6b6b;
  font-weight: 500;
}

.prontuario-value {
  font-size: 14px;
  color: #2e2e2e;
  font-weight: 600;
}
</style>